import React, { useState } from "react";

import { fakeShopEnabled, setFakeShopEnabled, freeEquipEnabled, setFreeEquipEnabled } from "../../shared/admin";
import AdminDirectory from "./AdminDirectory";

import styles from "./AdminPage.module.scss";

// The Admin page (the nav's Admin link, admins only): every admin / dev page as
// a neat directory, then the switches that live here.
export default function AdminPage() {
  const [fakeShop, setFakeShop] = useState(() => fakeShopEnabled());
  const [freeEquip, setFreeEquip] = useState(() => freeEquipEnabled());

  return (
    <div className={styles.admin}>
      <AdminDirectory />

      <h2 className={styles.sectionTitle}>Switches on this page</h2>

      <section className={styles.card} id="shop-test">
        <h2 className={styles.cardTitle}>Shop test switches</h2>
        <p className={styles.hint}>
          With this on, shop purchases skip payment and grant instantly ($0 test rows;
          egg packs stack real ledger entries), so the whole buy / own / equip flow is
          testable for free. The shop shows a notice while it&apos;s active.
        </p>
        <label className={styles.toggle}>
          <input
            type="checkbox"
            checked={fakeShop}
            onChange={(e) => { setFakeShop(e.target.checked); setFakeShopEnabled(e.target.checked); }}
          />
          <span>Test purchases (free, admin only)</span>
        </label>
        <p className={styles.hint}>
          Or skip buying altogether: with this on, pressing the price on any head,
          arena, flag or celebration equips it on the spot and the card reads as
          owned, exactly like a finished purchase. Nothing is granted server-side;
          it only changes what you have equipped locally, and the pretend
          purchases are forgotten when you switch this off.
        </p>
        <label className={styles.toggle}>
          <input
            type="checkbox"
            checked={freeEquip}
            onChange={(e) => { setFreeEquip(e.target.checked); setFreeEquipEnabled(e.target.checked); }}
          />
          <span>Equip anything without buying (admin only)</span>
        </label>
      </section>
    </div>
  );
}
